export default __webpack_public_path__ + "static/Ogg-Bold-ca7d02cce463c1172cca017e97deb59a.ttf";